import React from 'react';

import { Container } from 'react-bootstrap';

import { Ai2Layout } from '../layout/Ai2Layout';

const ReportingPage = () => {
  return (
    <Ai2Layout>
      <div className="ui">
        <Container fluid>
          <div className="flexVert offsetNavbar">reporting page goes here</div>
        </Container>
      </div>
    </Ai2Layout>
  );
};

export { ReportingPage };
